// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

require("component-responsive-frame/child");

let graph_width = document.querySelector("#decibel_graph").innerWidth || document.querySelector("#decibel_graph").clientWidth;

var margin = {top: 20, right: 5, bottom: 40, left: 135},
    width = graph_width - 10 - margin.left - margin.right,
    height = 400 - margin.top - margin.bottom;

// append the svg object to the body of the page
var svg = d3.select("#decibel_graph")
  .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
  .append("g")
    .attr("transform",
          "translate(" + margin.left + "," + margin.top + ")");

var data = require("./data.json");

  // Add X axis
  var x = d3.scaleLinear()
    .domain([0, 140])
    .range([ 0, width]);
  svg.append("g")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x).ticks(5).tickSizeOuter(0))
    .selectAll("text")
      .attr("transform", "translate(-10,0)rotate(-45)")
      .style("text-anchor", "end");


  // Y axis
  var y = d3.scaleBand()
    .range([ 0, height ])
    .domain(data.map(function(d) { return d.object; }))
    .padding(.1);
  svg.append("g")
    .call(d3.axisLeft(y))

  //Bars
  let bars = svg.selectAll("myRect")
    .data(data)
    .enter()
    .append("rect")
    .attr("x", x(0) )
    .attr("y", function(d) { return y(d.object); })
    .attr("width", function(d) { return x(d.decibel); })
    .attr("height", y.bandwidth() )
    .attr("fill", "#F06C00");

  svg.append("text")
    .attr("class", "x label")
    .attr("text-anchor", "end")
    .attr("x", width)
    .attr("y", height + 39.5)
    .text("Decibel levels");


window.onscroll = onScrollHandler;

function onScrollHandler() {
  const first = document.getElementById("first_scroll");
  const timeline = document.getElementById("timeline");
  const plane = document.getElementById("sticky_plane_1");
    if (
      window.pageYOffset >= first.offsetTop
      && window.pageYOffset < (timeline.offsetTop - first.offsetHeight - (window.innerHeight * 0.8))
      && window.innerWidth > 700
    ) {
      plane.style.position= "sticky";
    } else {
      plane.style.position= "relative";
    }
}
